var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "PaymentAffirm",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 73 44"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <circle cx="35.7" cy="16.5" r="1.4"/>
  <rect width="2.4" height="9.4" x="34.5" y="18.1"/>
  <path d="M43.9 17.9c-1.2 0-2.5.9-3 1.9v-1.7h-2.2v9.4h2.4v-4.4c0-1.8.7-2.9 2.3-2.9l1.3-2.3h-.8z"/>
  <path d="M53.4 17.9c-1 0-1.9.4-2.6 1.1-.6-.7-1.5-1.1-2.5-1.1-2.2 0-3.7 1.6-3.7 3.8v5.9h2.3v-5.9c0-.9.6-1.5 1.4-1.5.9 0 1.4.6 1.4 1.5v5.9H52v-5.9c0-.9.6-1.5 1.4-1.5s1.4.6 1.4 1.5v5.9h2.3v-5.9c.1-2.2-1.5-3.8-3.7-3.8z"/>
  <path d="M31.9 16.4c.3-.2.7-.2 1.1-.2l.5-1.7h-.2c-1-.1-2-.1-2.9.4-.7.5-1.1 1.3-1.1 2.2v1h-2.8v-.9c0-.3 0-.7.3-.9.3-.2.7-.2 1.1-.2l.5-1.7h-.2c-1-.1-2-.1-2.9.5-.7.5-1 1.3-1 2.2v1H23v1.7h1.1v7.7h2.4v-7.7h2.8v7.7h2.4v-7.7h1.6v-1.7h-1.6v-.9c0-.3 0-.6.2-.8z"/>
  <path d="M20.6 17.9c-.5 0-.9.1-1.2.5l-7.2 9.1H14c.7 0 1.3-.4 1.7-.9l4-5.1v6h2.2v-8.3c-.1-.6-.6-1.2-1.3-1.3z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/payment-affirm.svg